import { render, staticRenderFns } from "./teamEdit.vue?vue&type=template&id=679559a7&"
import script from "./teamEdit.vue?vue&type=script&lang=js&"
export * from "./teamEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports